import { render } from "./g-menu-sidebar.vue?vue&type=template&id=041313cf&scoped=true"
import script from "./g-menu-sidebar.vue?vue&type=script&lang=js"
export * from "./g-menu-sidebar.vue?vue&type=script&lang=js"

import "./g-menu-sidebar.vue?vue&type=style&index=0&id=041313cf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041313cf"]])

export default __exports__